var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 20.1567V15.6567C14.25 15.4578 14.171 15.267 14.0303 15.1264C13.8897 14.9857 13.6989 14.9067 13.5 14.9067H10.5C10.3011 14.9067 10.1103 14.9857 9.96967 15.1264C9.82902 15.267 9.75 15.4578 9.75 15.6567V20.1567C9.75 20.3556 9.67098 20.5464 9.53033 20.687C9.38968 20.8277 9.19891 20.9067 9 20.9067H4.5C4.30109 20.9067 4.11032 20.8277 3.96967 20.687C3.82902 20.5464 3.75 20.3556 3.75 20.1567V11.4848C3.75168 11.381 3.77411 11.2786 3.81597 11.1836C3.85783 11.0886 3.91828 11.003 3.99375 10.9317L11.4937 4.11607C11.632 3.98958 11.8126 3.91943 12 3.91943C12.1874 3.91943 12.368 3.98958 12.5062 4.11607L20.0062 10.9317C20.0817 11.003 20.1422 11.0886 20.184 11.1836C20.2259 11.2786 20.2483 11.381 20.25 11.4848V20.1567C20.25 20.3556 20.171 20.5464 20.0303 20.687C19.8897 20.8277 19.6989 20.9067 19.5 20.9067H15C14.8011 20.9067 14.6103 20.8277 14.4697 20.687C14.329 20.5464 14.25 20.3556 14.25 20.1567Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.9f57db0482a1f1800bf6b0b4165c25fc.svg";
export { ForwardRef as ReactComponent };